import OrderEditsWarningInventoryModeNone from "@commercetools-local/topics/order-edits/warning-inventory-mode-none.mdx";
import * as React from 'react';
export default {
  OrderEditsWarningInventoryModeNone,
  React
};